import { render } from "./SvgConverter.vue?vue&type=template&id=dfd6b28a"
import script from "./SvgConverter.vue?vue&type=script&lang=js"
export * from "./SvgConverter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__